module.exports = __webpack_public_path__ + "img/mgh-gotanda-sp.84bb8005.jpg";